<div class="container cards-terms-conditions-wrapper d-flex justify-content-center align-items-center" >
    <div class="spinner-border text-primary" role="status" *ngIf="showLoader">
        <span class="sr-only">Loading...</span>
    </div>
    <div
        id="cards-terms-conditions"
        *ngIf="!showLoader"
        class="mx-3 w-100 overflow-auto"
        [innerHTML]="termsConditionsHtml">
    </div>
</div>
